var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.92 21.68C26.92 27.62 22.3 31 15.46 31C12.3906 30.9977 9.3545 30.3646 6.54 29.14V21.28C9.3 22.78 12.74 23.9 15.46 23.9C17.3 23.9 18.52 23.42 18.52 21.9C18.52 17.94 6 19.42 6 10.3C6 4.48 10.56 1 17.24 1C19.96 1 22.68 1.4 25.42 2.5V10.26C22.8879 8.92737 20.0807 8.2016 17.22 8.14C15.5 8.14 14.34 8.64 14.34 9.94C14.34 13.64 26.92 11.88 26.92 21.7V21.68Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrip);
export default __webpack_public_path__ + "static/media/strip.a24660072f058f80f3484ce957f94fc5.svg";
export { ForwardRef as ReactComponent };